import { useState } from "react";
import TranslationTable from "./TranslationTable";

function CountryRender(props) {

    const [shown, isShown] = useState(false);

    const toggleShown = () => {
        isShown(!shown);
    }

    return (
        <div className='card'>
                <div className='card-content'>
                    <h1 className='title has-text-centered'>{props.data.name.common}</h1>
                    <div className='columns is-mobile is-multiline'>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>Official name</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.name.official}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>Capital</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {!props.data.capital ? '' : props.data.capital.join(', ')}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>Capital's latitude and longitude</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.latlng.join(', ')}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>Timezones</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.timezones.join(', ')}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>Continent</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.continents.join(', ')}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>Region</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.region}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>Subregion</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.subregion}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>Languages</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.languages ? Object.values(props.data.languages).join(', ') : ''}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>Population</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.population}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>TLD</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.tld}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>CCA2</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.cca2}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>CCA3</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.cca3}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>CIOC</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.cioc}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>Independent</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.independent ? 'yes' : 'no'}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>Status</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.status}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>UN member</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.unMember ? 'yes' : 'no'}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>Currency</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.currencies ? Object.keys(props.data.currencies) : ''}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>Telephone country codes</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <p>Root: {props.data.idd.root}</p>
                            <p>Suffixes: {props.data.idd.suffixes ? props.data.idd.suffixes.join(', ') : ''}</p>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>Alternate spellings</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.altSpellings.join(', ')}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>Landlocked</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.landlocked ? 'yes' : 'no'}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>Borders</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.borders ? props.data.borders.join(', ') : 'none'}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>Area</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.area}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>FIFA</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.fifa}
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            <strong>Start of week</strong>
                        </div>
                        <div className='column is-half-mobile is-2-desktop'>
                            {props.data.startOfWeek}
                        </div>
                        <div className='column is-mobile is-12-desktop'>
                            <strong>Translations</strong>
                            <button className="translationButton ml-4 button is-small is-info is-light" onClick={() => toggleShown()}> Toggle visibility</button>
                        </div>
                        <div className='column is-mobile is-12-desktop '>
                            {shown && <TranslationTable international={props.data.translations} />}
                        </div>
                    </div>
                </div>
                <footer className='card-footer'>
                    <p className='card-footer-item'><img src={props.data.flags.png} alt='Flag' /></p>
                    <p className='card-footer-item'><img src={props.data.coatOfArms.png} alt='Coat of Arms' /></p>
                </footer>
            </div>
    )
}

export default CountryRender;